import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import Icon from 'components/Icon';

import { getCustomerDisplayState } from '../rdx/reducer';
import { SET_SELECTED_SCREEN } from '../rdx/actionTypes';

const ScreenSelectMenu = () => {
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const { hasPermission, screens, selectedScreen } = useSelector(
    getCustomerDisplayState,
  );

  const handleClose = () => {
    setAnchorEl(null);
  };

  const selectScreen = (screen, index) => {
    dispatch({ type: SET_SELECTED_SCREEN, payload: { screen, index } });
    handleClose();
  };

  if (!hasPermission) {
    return (
      <Icon
        name="icon_error-triangle_alt"
        style={{ color: 'yellow' }}
        title="Multi-screen window placement permission denied or not supported"
      />
    );
  }

  return (
    <>
      <Button
        onClick={e => setAnchorEl(e.currentTarget)}
        style={{ color: 'white' }}
      >
        {selectedScreen
          ? `Screen ${selectedScreen.index + 1}`
          : 'No screen selected'}
        <Icon name="arrow_triangle-down" style={{ color: 'white' }} />
      </Button>
      <Menu
        id="screen-select-menu"
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={handleClose}
        style={{ top: '33px' }}
      >
        {screens.map((screen, index) => (
          <MenuItem
            key={String(index)}
            onClick={() => selectScreen(screen, index)}
          >
            Screen {index + 1} ({screen.label})
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ScreenSelectMenu;
